export default "__VITE_ASSET__Cx9tXE6l__"